import { createNavigationContainerRef, useRoute } from '@react-navigation/native';
import { useShell } from '../ui/ShellContext';
import { TAB_NAMES } from './tabs';

export const navigationRef = createNavigationContainerRef<Record<string, object | undefined>>();

/**
 * Navigate to any registry screen by name, with params. Handles tab-root screens (which live
 * inside the bottom-tab navigator) transparently.
 *   go('EmployeeDetail', { id: 42 })
 */
export function go(name: string, params?: Record<string, unknown>) {
  if (!navigationRef.isReady()) return;
  const nav = navigationRef.navigate as unknown as (n: string, p?: object) => void;
  if (TAB_NAMES.has(name)) nav('Tabs', { screen: name, params });
  else nav(name, params);
}

/** Hook form of `go` for components. */
export function useGo() {
  return useShell().go;
}

/**
 * Typed access to the current screen's params. Values that came from a web URL
 * (e.g. /hr/employees/42) are strings — convert with Number() where needed.
 */
export function useParams<T extends object = Record<string, string | undefined>>(): Partial<T> {
  return (useRoute().params ?? {}) as Partial<T>;
}
